<template>
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 account_section">
    <div class="my-account-title" v-if="FormInputs.IndividualLabels">Shipping Address</div>
    <div class="my-account-title" v-else>Location Information</div>
    <div class="account_login_info">
      <div class="row" v-show="FormInputs.ContactIsMultiLocation">
        <div class="col-lg-5 col-md-5 col-sm-5 col-xs-5">
          <label class="account_label" v-if="FormInputs.BusinessLabels">Multi-Location Business</label>
          <label class="account_label" v-else>Multi-Location Organization</label>
        </div>
        <div class="col-lg-7 col-md-7 col-sm-7 col-xs-7">
          <p class="account_p" v-if="AccountView.primaryContact.isMultiLocation == true">Yes</p>
          <p class="account_p" v-else>No</p>
        </div>
      </div>
      <div class="row" v-if="FormInputs.OfficeLocationName">
        <div class="col-lg-5 col-md-5 col-sm-5 col-xs-5">
          <label class="account_label">Location Name</label>
        </div>
        <div class="col-lg-7 col-md-7 col-sm-7 col-xs-7">
          <p class="account_p capitalized-text">{{AccountView.primaryContact.officeLocation.name}}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-5 col-md-5 col-sm-5 col-xs-5">
          <label class="account_label">Shipping Address</label>
        </div>
        <div class="col-lg-7 col-md-7 col-sm-7 col-xs-7">
          <p class="account_p capitalized-text">{{AccountView.primaryContact.officeLocation.streetAddress + ", " + IsEmpty(IsNull(AccountView.primaryContact.officeLocation.suite)) + " " + AccountView.primaryContact.officeLocation.city + ", " + AccountView.primaryContact.officeLocation.state + " " + AccountView.primaryContact.officeLocation.zip}}</p>
        </div>
      </div>
      <div class="row" v-show="FormInputs.OfficeLocationPhoneNumber">
        <div class="col-lg-5 col-md-5 col-sm-5 col-xs-5">
          <label class="account_label">Phone Number</label>
        </div>
        <div class="col-lg-7 col-md-7 col-sm-7 col-xs-7">
          <p class="account_p"> <span v-if="AccountView.primaryContact.officeLocation.countryCode">(</span>{{(AccountView.primaryContact.officeLocation.countryCode || "") }}<span v-if="AccountView.primaryContact.officeLocation.countryCode">)</span> {{ (AccountView.primaryContact.officeLocation.areaCode || "")}}<span v-if="AccountView.primaryContact.officeLocation.areaCode">-</span>{{ (AccountView.primaryContact.officeLocation.phone || "") }}</p>
        </div>
      </div>
      <div class="row" v-show="FormInputs.OfficeLocationEmailAddress">
        <div class="col-lg-5 col-md-5 col-sm-5 col-xs-5">
          <label class="account_label" v-if="FormInputs.BusinessLabels">Office Contact Email Address</label>
          <label class="account_label" v-else>Location Contact Email Address</label>
        </div>
        <div class="col-lg-7 col-md-7 col-sm-7 col-xs-7">
          <p class="account_p">{{AccountView.primaryContact.officeLocation.emailAddress}}</p>
        </div>
      </div>
      <div class="row" v-show="FormInputs.OfficeLocationContact">
        <div class="col-lg-5 col-md-5 col-sm-5 col-xs-5">
          <label class="account_label" v-if="FormInputs.BusinessLabels">Office Contact</label>
          <label class="account_label" v-else>Location Contact</label>
        </div>
        <div class="col-lg-7 col-md-7 col-sm-7 col-xs-7">
          <p class="account_p">{{IsNull(AccountView.primaryContact.officeLocation.contactFirstName) + " " + IsNull(AccountView.primaryContact.officeLocation.contactLastName)}}</p>
        </div>
      </div>
      <div class="row" v-show="FormInputs.OfficeLocationContactRole">
        <div class="col-lg-5 col-md-5 col-sm-5 col-xs-5">
          <label class="account_label" v-if="FormInputs.BusinessLabels">Role in Business</label>
          <label class="account_label" v-else>Role in Organization</label>
        </div>
        <div class="col-lg-7 col-md-7 col-sm-7 col-xs-7">
          <p class="account_p" v-if="AccountView.primaryContact.officeLocation.contactRole">{{AccountView.primaryContact.officeLocation.contactRoleDesc}}</p>
        </div>
      </div>
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 center">
        <button class="btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-130 g-font-size-17" v-on:click="EditSection()">Edit</button>
      </div>
    </div>

    <loading-component v-if="isLoading"></loading-component>
    <!--Edit Mode START-->
    <div v-if="isModalShown">
      <div class="modal-mask" role="dialog">
        <div class="overlay-mask">
          <div class="modal-dialog modal-lg">
            <div class="modal-content modal-edit-bg">
              <div class="modal-body">
                <div v-if="isFormLoading" class="row">
                  <page-loader></page-loader>
                </div>
                <div v-else>
                  <div class="close_btn" v-on:click="CloseModal()"></div><br>
                  <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <edit-location-info 
                       @addressCheck="ValidateAddress()" 
                       v-bind:AccountEdit="AccountEdit"
                       :FormInputs="FormInputs" 
                       :OfficeLocationValidationResult="OfficeLocationValidationResult" 
                       :State="State" 
                       :RoleNonProfit="RoleNonProfit" 
                       :RoleBusiness="RoleBusiness"
                       :IsValidNPI="IsValidNPI"
                       :IsAddressValidating="IsAddressValidating"></edit-location-info>
                      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 center">
                        <button class="btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-130 g-mx-10 g-font-size-17" v-on:click="SaveAccount()">Save</button>
                        <button class="btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-130 g-mx-10 g-font-size-17" v-on:click="CloseModal()">Cancel</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import EditLocationInfo from "@/components/portal/userAccount/accountEdit/EditLocationInfo";
import LoadingComponent from "@/components/shared/LoadingComponent";
import PageLoader from "@/components/shared/PageLoader";
export default {
  props: [
    "AccountView",
    "AccountEdit",
    "FormInputs",
    "State",
    "RoleNonProfit",
    "RoleBusiness",
    "isFormLoading"
  ],
  components: { EditLocationInfo, LoadingComponent, PageLoader },
  data() {
    return {
      isModalShown: false,
      OfficeLocationValidationResult: {},
      isLoading: false,
      IsValidNPI: false,
      IsAddressValidating: false
    };
  },
  methods: {
    EditSection() {
      document.body.classList.add("body-overflow");
      this.OfficeLocationValidationResult = {};
      this.isModalShown = !this.isModalShown;
      this.$emit("load");
      this.$emit("clicked");
    },
    CloseModal() {
      this.isModalShown = false;
      document.body.classList.remove("body-overflow");
    },
    IsPhoneEmpty(Phoneparams) {
      if (Phoneparams != "") return Phoneparams + "-";
      return Phoneparams;
    },
    SaveAccount() {
    if(this.AccountEdit.primaryContact.officeLocation.streetAddress){
      let check_PO_BOX  = this.checkIfAddressHasPO_BOX(this.AccountEdit.primaryContact.officeLocation.streetAddress.toString()) 
      if(check_PO_BOX == true){
        alert("Sorry, our labs cannot ship to a PO BOX. Please enter a valid shipping address.")
          return
      }
    }

      this.AccountEdit.eyeDoctors = null

      this.isLoading = true;
      this.OfficeLocationValidationResult = {};
      axios
        .post("/Account/MyLocationInformation", this.AccountEdit, {
          headers: { Authorization: "Bearer " + localStorage.getItem("token") }
        })
        .then(response => {
          var _this = this;
          this.isLoading = false;
          if (response.data.isSuccess == true) {
            this.$emit("selfReload");
            this.CloseModal();
            _this.$emit("success");

            var shippingAddress = {
                shippingAddressLineOne: response.data.raw.primaryContact.officeLocation.streetAddress,
                shippingAddressLineTwo: response.data.raw.primaryContact.officeLocation.suite,
                shippingCity: response.data.raw.primaryContact.officeLocation.city,
                shippingState: response.data.raw.primaryContact.officeLocation.state,
                shippingPostalCode: response.data.raw.primaryContact.officeLocation.zip,
            }

            localStorage.setItem("shippingAddress", JSON.stringify(shippingAddress));

          } else {
            _this.OfficeLocationValidationResult =
              response.data.raw.primaryContact.officeLocation.validationResult;
          }
        })
        .catch(function(error) {
          console.log(error);
          _this.$router.push({name: 'Error'});
        });
    },
    ValidateAddress() {
      var _this = this;
        if (true) {
            _this.IsAddressValidating = true;
            var params = {
            Address2: _this.AccountEdit.primaryContact.officeLocation.streetAddress,
            City: _this.AccountEdit.primaryContact.officeLocation.city,
            State: _this.AccountEdit.primaryContact.officeLocation.state,
            Zip5: _this.AccountEdit.primaryContact.officeLocation.zip
            };
            axios
            .post("/Account/GetAddressDetails/", params)
            .then(response => {
                if (response.data.isSuccess) {
                var details = response.data.raw;
                _this.AccountEdit.primaryContact.officeLocation.streetAddress = details.address2;
                _this.AccountEdit.primaryContact.officeLocation.city = details.city;
                _this.AccountEdit.primaryContact.officeLocation.state = details.state;
                _this.AccountEdit.primaryContact.officeLocation.zip = details.zip5;
                _this.OfficeLocationValidationResult.OfficeLocationZip = null;
                _this.IsAddressValidating = false;
                _this.IsValidNPI = true;
                } else {
                _this.OfficeLocationValidationResult.OfficeLocationZip = response.data.errorMessage;
                _this.IsAddressValidating = false;
                _this.IsValidNPI = false;
                }
            })
            .catch(error => {
                console.log(error);
            });
        }
    }
  }
};
</script>



// WEBPACK FOOTER //
// LocationInfo.vue?7210c975